import React from "react";
import PropTypes from "prop-types";

import {DateFormatter} from "../../../services/date";
import KeyValueHorizontal from "../../../components/KeyValueHorizontal";
import {isValidDateObject} from "../../../services/date/validators";

import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import {DatePicker} from "@mui/x-date-pickers";
import TextField from "@mui/material/TextField/TextField";
import FormControlLabel from "@mui/material/FormControlLabel/FormControlLabel";
import Switch from "@mui/material/Switch/Switch";


const StepOffer = props => {
    const {formik, isEditMode} = props;

    const {minPeople, minNight, price} = formik.values;
    const minPrice = (parseInt(minPeople) || 0) * (parseInt(minNight) || 0) * (parseFloat(price) || 0).toFixed(2);

    return (
        <React.Fragment>
            <Typography variant="h6">
                Offerta
            </Typography>

            <Box sx={{my: 4}}>
                <Grid container spacing={3}>
                    {
                        isEditMode ?
                            <Grid item xs={12}>
                                <Box sx={{pb: 2}}>
                                    <KeyValueHorizontal horizontalDivider={true} pairs={[
                                        ["Data inizio", DateFormatter.shortString(formik.values.startDate)],
                                        ["Data fine", DateFormatter.shortString(formik.values.endDate)]
                                    ]}/>
                                </Box>
                            </Grid>
                            :
                            <React.Fragment>
                                <Grid item xs={12} md={6}>
                                    <DatePicker value={formik.values.startDate}
                                                onChange={date => formik.setFieldValue("startDate", date)}
                                                disablePast
                                                label="Data inizio"
                                                closeOnSelect
                                                disableHighlightToday
                                                showDaysOutsideCurrentMonth
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        error: Boolean(formik.touched.startDate) && Boolean(formik.errors.startDate),
                                                        helperText: formik.touched.startDate && formik.errors.startDate
                                                    }
                                                }}
                                                />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <DatePicker value={formik.values.endDate}
                                                onChange={date => formik.setFieldValue("endDate", date)}
                                                disablePast
                                                minDate={formik.values.startDate}
                                                defaultCalendarMonth={isValidDateObject(formik.values.startDate) ? formik.values.startDate : undefined}
                                                label="Data fine"
                                                closeOnSelect
                                                disableHighlightToday
                                                showDaysOutsideCurrentMonth
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        error: Boolean(formik.touched.endDate) && Boolean(formik.errors.endDate),
                                                        helperText: formik.touched.endDate && formik.errors.endDate
                                                    }
                                                }}
                                                />
                                </Grid>
                            </React.Fragment>
                    }

                    <Grid item xs={12}>
                        <FormControlLabel
                            control={
                                <Switch
                                    id="petsAllowed"
                                    name="petsAllowed"
                                    color="primary"
                                    checked={formik.values.petsAllowed}
                                    onChange={formik.handleChange}/>
                            }
                            label={formik.values.petsAllowed ? "Animali ammessi" : "Animali non ammessi"}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField type="number"
                                   label="Minimo persone"
                                   fullWidth
                                   id="minPeople"
                                   value={formik.values.minPeople}
                                   onChange={formik.handleChange}
                                   error={formik.touched.minPeople && Boolean(formik.errors.minPeople)}
                                   helperText={formik.touched.minPeople && formik.errors.minPeople}/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField type="number"
                                   label="Minimo notti"
                                   fullWidth
                                   id="minNight"
                                   value={formik.values.minNight}
                                   onChange={formik.handleChange}
                                   error={formik.touched.minNight && Boolean(formik.errors.minNight)}
                                   helperText={formik.touched.minNight && formik.errors.minNight}/>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField type="number"
                                   inputProps={{step: 0.01}}
                                   label="Prezzo a notte per persona"
                                   fullWidth
                                   id="price"
                                   value={formik.values.price}
                                   onChange={formik.handleChange}
                                   error={formik.touched.price && Boolean(formik.errors.price)}
                                   helperText={formik.touched.price && formik.errors.price}/>
                    </Grid>

                    <Grid item xs={12}>
                        <Box sx={{py: 2}}>
                            <KeyValueHorizontal valueTextVariant="h5"
                                                pairs={[["Prezzo minimo calcolato", `${minPrice} €`]]}/>
                        </Box>
                    </Grid>

                </Grid>
            </Box>
        </React.Fragment>
    )
};

StepOffer.propTypes = {
    formik: PropTypes.object.isRequired,
    isEditMode: PropTypes.bool.isRequired,
};

export default StepOffer;